<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <vip-level-member-table></vip-level-member-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import vipLevelMemberTable from './VIPLevelMemberTable.vue'

  export default {
    name: 'vipLevelMember',
    components: {vipLevelMemberTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelMember.vue